module.exports = __webpack_public_path__ + "img/bg_01@2x.b5aa5829.png";